import {DELETE_LID} from "../constants/constants";

export const deleteLid = (step, index) => {
    return {
        type : DELETE_LID,
        payload : {
            step : step,
            index : index
        }
    };
};


// WEBPACK FOOTER //
// ./src/actions/deleteLid.js